export default __webpack_public_path__ + "static/media/intro_de.fa1d2ad3.mp4";